import { useNavigate } from 'react-router-dom';
import { SEGMENTS } from './data';
import HealthAuthorityBand from './HealthAuthorityBand';

export default function SegmentsSection() {
  const navigate = useNavigate();

  const regularSegments = SEGMENTS.filter((segment) => !segment.featured);

  return (
    <section id="segmentos" className="scroll-mt-28 bg-background-50 py-20 md:py-28">
      <div className="mx-auto w-full max-w-[1240px] px-6">
        <div className="mx-auto mb-12 max-w-3xl text-center">
          <span className="inline-flex items-center rounded-full border border-primary-200 bg-primary-50 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.22em] text-primary-700">
            Incentivo inteligente
          </span>
          <h2 className="mt-5 font-heading text-3xl font-bold leading-[1.1] tracking-[-0.02em] text-foreground-950 md:text-5xl">
            Qualquer time que precise bater meta <span className="text-primary-600">pode ser incentivado</span>
          </h2>
        </div>
      </div>

      <HealthAuthorityBand />

      <div className="mx-auto w-full max-w-[1400px] px-4 md:px-6">
        <div className="grid gap-3 md:grid-cols-3">
          {regularSegments.map((segment) => (
            <button
              key={segment.title}
              type="button"
              onClick={() => navigate('/solicitar-demo')}
              className="group relative block h-[480px] cursor-pointer overflow-hidden rounded-3xl border border-background-200 text-left md:h-[560px]"
            >
              <img
                src={segment.image}
                alt={segment.title}
                className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/30 to-foreground-950/50"></div>
              <div className="relative z-10 flex h-full flex-col justify-between p-7 md:p-8">
                <h3 className="max-w-[85%] font-heading text-2xl font-semibold leading-snug text-background-50 md:text-3xl">
                  {segment.title}
                </h3>
                <div>
                  <span className="mb-4 flex h-11 w-11 items-center justify-center rounded-full bg-background-50 text-foreground-950 transition-transform duration-500 group-hover:-translate-y-1">
                    <i className="ri-arrow-right-up-line text-lg"></i>
                  </span>
                  <p className="max-w-[92%] text-sm leading-relaxed text-background-100">{segment.description}</p>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}